<template>
  <footer class="text-center bg-gray-200 sticky bottom-0 mt-40">
    <small class="italic"><a href="https://github.com/chidimi">copyright © 2021 chidimi</a></small>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MemoFooter'
})
</script>

